import React from "react";
import { Link } from "react-router-dom";
import backgroundImage from "../../assets/subfooter.jpg";

const FullScreenImage = () => {
  return (
    <section
      className="relative h-[80vh] min-[1024px]:max-[1535px]:!h-[72vh] bg-cover bg-center"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="absolute inset-0 bg-black opacity-60"></div>{" "}
      {/* Dark overlay */}
      <div className="relative z-10 flex flex-col justify-center items-center h-full text-white text-center px-2 min-[1024px]:max-[1535px]:!px-3">
        <h2 className="text-3xl sm:text-5xl md:text-6xl lg:text-7xl font-bold mb-12 sm:mb-16 md:mb-20 px-4 min-[1024px]:max-[1535px]:!text-4xl min-[1024px]:max-[1535px]:!mb-8">
          STEP INTO YOUR FUTURE
        </h2>
        <div className="flex flex-col sm:flex-row gap-4 sm:gap-8 items-center justify-center min-[1024px]:max-[1535px]:!gap-3">
          <Link to="/contact" className="bg-custom-pink font-bold py-2 sm:py-3 md:py-4 px-6 sm:px-8 md:px-12 lg:px-20 rounded-full text-white hover:bg-opacity-80 transition duration-300 text-center w-full sm:w-auto min-[1024px]:max-[1535px]:!py-2 min-[1024px]:max-[1535px]:!px-6 min-[1024px]:max-[1535px]:!text-sm">
            REQUEST MORE INFO
          </Link>
          <a href="https://apply.jrsys.ac.tz/" target="_blank" rel="noreferrer" className="bg-gold py-2 font-bold sm:py-3 md:py-4 px-6 sm:px-8 md:px-12 lg:px-20 rounded-full text-white hover:bg-opacity-80 transition duration-300 text-center w-full sm:w-auto min-[1024px]:max-[1535px]:!py-2 min-[1024px]:max-[1535px]:!px-6 min-[1024px]:max-[1535px]:!text-sm">
            APPLY NOW
          </a>
          {/* HIDDEN 2026-08-04 at client request (academics page hidden) — unhide by restoring this Link.
          <Link to="/academics" className="bg-custom-pink font-bold py-2 sm:py-3 md:py-4 px-6 sm:px-8 md:px-12 lg:px-20 rounded-full text-white hover:bg-opacity-80 transition duration-300 text-center w-full sm:w-auto min-[1024px]:max-[1535px]:!py-2 min-[1024px]:max-[1535px]:!px-6 min-[1024px]:max-[1535px]:!text-sm">
            EXPLORE PROGRAMS
          </Link>
          */}
        </div>
      </div>
    </section>
  );
};

export default FullScreenImage;
